import { debounce } from 'lodash'
import { useEffect, useRef } from 'react'
import { useTextSelectionMenuActions } from '../store/storeTextSelectionMenu'

export const useTextSelectionMenu = () => {
    const { openMenu, closeMenu } = useTextSelectionMenuActions()

    const debouncedHandlerRef = useRef(
        debounce((target: EventTarget & Element) => {
            const sel = window.getSelection()

            if (!sel || sel.isCollapsed) {
                closeMenu()
                return
            }

            const range = sel.getRangeAt(0)
            const text = sel.toString()

            const selectedNode = sel.anchorNode
            const parentElement = selectedNode?.parentElement

            const rects = Array.from(range.getClientRects())
            const rect = rects.findLast(({ x, y, width, height }) => x && y && width && height)

            const menuWidth = 173

            if (!parentElement || !rect) {
                return
            }

            const pointX = rect.left
            const normalLeftPos = pointX - menuWidth <= 0 ? rect.left : pointX
            const normalPosX =
                normalLeftPos + menuWidth > window.innerWidth
                    ? rect.right - menuWidth
                    : normalLeftPos

            openMenu(
                parentElement,
                {
                    x: normalPosX,
                    y: rect.top + window.scrollY + 30,
                },
                text,
            )
        }, 250),
    )

    const handleTextSelectionEnd = (event: React.SyntheticEvent) => {
        const target = event.currentTarget
        debouncedHandlerRef.current?.(target)
    }

    useEffect(() => {
        return () => {
            debouncedHandlerRef.current.cancel()
        }
    }, [])

    return { handleTextSelectionEnd }
}
